import { ISettlement, ISettlementDto } from '../index';

export function mapSettlementList(dto: ISettlementDto): ISettlement {
  return {
    id: dto.id,
    name: dto.name,
  };
}
